<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="9" mx-auto>
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0 py-2">
            <v-layout row wrap>
              <v-flex xs12>
                <v-combobox
                v-model="curComm"
                label="Community"
                :items="commList"
                item-text="comm_name"
                item-value="comm_id"
                placeholder="Choose"
                @input="curComm ? loadRoles(curComm) : ''"
                filled
                clearable
                ></v-combobox>
              </v-flex>
              <v-flex xs6 v-if="curComm && curComm.comm_id">
                <v-text-field
                class="pt-0"
                append-icon="mdi-account-search"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search by Name, Description, etc.':'Search'"
                hide-details
                v-model="search"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-if="curComm && curComm.comm_id">
                <v-download-as
                :headers="roleHead"
                :items="roles"
                title="Roles list"
                ></v-download-as>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="px-0 py-3" v-if="curComm && curComm.comm_id">
            <v-data-table
            :headers="roleHead"
            :items="roles"
            hide-default-footer
            class="elevation-2"
            :search="search"
            disable-pagination
            sort-by="role_cat"
            :mobile-breakpoint="0"
            >
            <template slot="item" slot-scope="props">
              <tr @click="prepareUpdate(props.item)">
                <td>{{ props.item.staff_role }}</td>
                <td>{{ props.item.role_cat }}</td>
                <td>{{ props.item.short_form }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <!-- create / update / delete roles -->
      <v-form ref="lForm" @submit.prevent="saveChanges(lAction)" v-else>
        <v-card flat>
          <v-flex xs12 sm9 md7 mx-auto>
            <v-card-title class="px-0 py-2">
              {{handy.startWithUpper(lAction) + ' Role'}}
            </v-card-title>
            <v-card-text class="px-0 py-3">
              <v-flex xs12 class="pa-2">
                <v-select
                label="Category"
                :items="['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'SAFTY/SECURITY', 'OTHERS']"
                v-model="lRole.role_cat"
                :rules="[rules.required]"
                hide-details
                maxlength="20"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-text-field
                v-model.trim="lRole.staff_role"
                label="Role Name"
                :rules="[rules.required]"
                hide-details
                maxlength="50"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 class="pa-2">
                <v-text-field
                label="Short Form of Role Name"
                v-model="lRole.short_form"
                :rules="[rules.required]"
                maxlength="8"
                hide-details
                ></v-text-field>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="lAction === 'update'" @click.stop="deleteRole">Delete</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges">Close</v-btn>
              <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
            </v-card-actions>
          </v-flex>
        </v-card>
      </v-form>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

  </v-col>
</v-row>
<!-- snack bar for error reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="3000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import VDownloadAs from '@/components/VDownloadAs.vue'
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  components:
  {
    'v-download-as': VDownloadAs
  },
  data () {
    return {
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      config: config,
      handy: handy,
      rules: handy.rules,
      search: '',
      beingSaved: false,
      lAction: 'view',
      lRole: {},
      roles: [],
      roleHead: [
        { text: 'Role Name', value: 'staff_role' },
        { text: 'Category', value: 'role_cat' },
        { text: 'Short Form', value: 'short_form' }
      ],
      curComm: '',
      commList: []
    }
  },
  created () {
    this.loadComm()
  },
  mounted () {

  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    prepareCreate () {
      if (!this.curComm) {
        this.msg('Please choose a community to proceed', 2)
      } else {
        this.lRole = {
          comm_id: this.curComm.comm_id,
          staff_role: ''
        }
        this.lAction = 'create'
      }
    },
    prepareUpdate(curRole) {
      this.lRole = Object.assign({}, curRole) // keep the original object safely before changes
      this.lAction = 'update'
    },
    saveChanges (curAction) {
      if (curAction === 'delete') {
        if (!confirm('Sure, you want to delete the role "' + this.lRole.staff_role + '"?')) {
          return
        }
      } else if (!this.$refs.lForm.validate()) {
        return
      }
      // proceed with changes
      if (!this.lRole.short_form || !this.lRole.role_cat) {
        this.msg('Please enter category as well as its short form to show it in daily report', true)
      } else {
        this.beingSaved = true
        this.axios.post(config.SMARTILITY_API_URL + '/role/' + (curAction + '-role'), this.lRole)
        .then(response => {
          this.loadRoles()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data, 0)
          this.beingSaved = false
        })
      }
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    deleteRole () {
      this.saveChanges('delete')
    },
    loadComm () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id
        }
      }
      this.axios.get(config.API_URL + '/getStaffRolesByCommId/', qry)
      .then(response => {
        this.roles = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.roles = []
      })
    }
  }
}
</script>
